import React, {ChangeEvent, FC} from 'react'
import {SelectAllInterface} from '../types'

const SelectAll: FC<SelectAllInterface> = ({
                                             selectAll,
                                             setSelectAll,
                                             setSelectedItems,
                                             data,
                                           }) => {

  const handleSelectAllChange = (e: ChangeEvent<HTMLInputElement>) => {

    const isChecked = e.target.checked
    setSelectAll(isChecked)

    if (isChecked) {
      const allItemIds = data.map(item => item.id)
      setSelectedItems(allItemIds)
    } else {
      setSelectedItems([])
    }
  }

  return (
    <div className="form-check form-check-sm form-check-custom form-check-solid">
      <input className="form-check-input me-3"
             type="checkbox"
             value="1"
             checked={selectAll}
             onChange={handleSelectAllChange}
      />
    </div>
  )
}

export {SelectAll}